import {Injectable} from '@angular/core';
import {CONFIG} from './config';
import {
    TPlasticSafe,
    TDevicerBios,
    TDevicerFrom,
    TDevicerHttp,
    TGaleriaTipo,
    TProfileTeam,
    TMonth,
    TUpperLowerCase,
    TVersionText, TAction, TFederalIbge,
} from './enum';
import {Observable} from 'rxjs/Rx';
import {
    AlertController,
    LoadingController,
    ToastController,
    Platform,
    NavController,
    ItemSliding,
    ActionSheetController,
    ModalController,
    App, PickerController, Keyboard,
} from 'ionic-angular';
import {StatusBar} from "@ionic-native/status-bar";
import {Device} from "@ionic-native/device";
import {AppVersion} from "@ionic-native/app-version";
import {DeviceDetectorService} from "ngx-device-detector";
import {HttpService} from "../providers/http-service";
import {Observer} from "rxjs/Observer";
import {ImagePicker, ImagePickerOptions, OutputType} from "@ionic-native/image-picker";
import * as sparkMD5 from 'spark-md5';
import {WheelSelector} from "@ionic-native/wheel-selector";
import {YoutubeVideoPlayer} from "@ionic-native/youtube-video-player";
import {DataService} from "../providers/data-service";
import {Vibration} from "@ionic-native/vibration";
import {Camera, CameraOptions} from "@ionic-native/camera";
import {TapticEngine} from "@ionic-native/taptic-engine";
import {HttpHeaders} from '@angular/common/http';

//#MIGRATE
export enum TJSFor {jsForMin, jsForMax, jsForSum, jsForCat, jsForCount}

export enum TStatusBar {sbStyleDefault, sbStyleLightContent, sbBackupRestore}

export enum TFileTipo {ftTipos, ftTexto, ftImage, ftVideo, ftAudio}

export enum TFileType {ftNao, ftExe, ftTxt, ftCsv, ftSql, ftSon, ftXml, ftPdf, ftPng, ftJpg, ftMp3, ftMp4, ftYou, ftSwf}

export enum TFieldType {ftFile, ftDoc, ftCpf, ftCnpj, ftCity, ftDate, ftHour, ftData, ftHora, ftInfo, ftLine, ftLink, ftText, ftHtml, ftQtde, ftReal, ftMail, ftFone, ftPicker, ftSheet, ftShaay, ftSheey, ftRadio, ftCheck, ftPutin, ftPaint, ftColor}

export enum TModalClick {mcFoto, mcLine, mcPlus, mcMore, mcAction}

//#MIGRATE
export enum TModalAlert {maWhite, maAlert, maDanger}

//#MIGRATE
export enum TChooseType {ctSheet, ctWheel}

export enum TGoogleAnalytic {gaPageview}



//todo: Retorna o nome do PC? MIDUKAN pq nao temos cordova no Browser?
//declare var cordova;
//cordova.plugins.deviceName;

declare const fabric: any;


@Injectable()
export class Util {

    websterOpen: boolean;
    websterPage: number = -1;

    isKeyboard: boolean;

    monthShortNames = 'JAN, FEV, MAR, ABR, MAI, JUN, JUL, AGO, SET, OUT, NOV, DEZ';

    backpColorbar: TStatusBar;

    lightGallery: any;
    audioSound: HTMLAudioElement;

    showVideo: any;
    players: any = {};

    pageroot: boolean = true;

    constructor(public alertCtrl: AlertController, public loadingCtrl: LoadingController, public platform: Platform,
                public toastCtrl: ToastController, public statusBar: StatusBar, public http: HttpService,
                public appVersion: AppVersion, public keyboard: Keyboard,
                public taptic: TapticEngine, public vibration: Vibration, //Sensitive Action
                public app: App, private device: Device, public deviceService: DeviceDetectorService,
                public dataService: DataService, public camera: Camera,
                public imagePicker: ImagePicker, public modalCtrl: ModalController,
                public actionSheetCtrl: ActionSheetController, public pickerCtrl: PickerController,
                private wheelSelector: WheelSelector,
                public youtube: YoutubeVideoPlayer) {
    }

    //Transform Stream em Base64 em Stream
    base64 = {

        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

        encode: function (input) {
            let output = "";
            let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            let i = 0;

            input = this._utf8_encode(input);

            while (i < input.length) {

                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) enc3 = enc4 = 64;
                else if (isNaN(chr3)) enc4 = 64;

                output = output +
                    this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                    this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

            }

            return output;
        },

        decode: function (input) {
            let output = "";
            let chr1, chr2, chr3;
            let enc1, enc2, enc3, enc4;
            let i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

                enc1 = this._keyStr.indexOf(input.charAt(i++));
                enc2 = this._keyStr.indexOf(input.charAt(i++));
                enc3 = this._keyStr.indexOf(input.charAt(i++));
                enc4 = this._keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) output = output + String.fromCharCode(chr2);
                if (enc4 != 64) output = output + String.fromCharCode(chr3);

            }

            output = this._utf8_decode(output);

            return output;

        },

        _utf8_encode: function (string) {
            string = string.replace(/\r\n/g, "\n");
            let utftext = "";

            for (let n = 0; n < string.length; n++) {

                const c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }

            return utftext;
        },

        _utf8_decode: function (utftext) {
            let string = "";
            let i = 0;
            let c = 0;
            //var c1 = 0;
            let c2 = 0;
            let c3 = 0;

            while (i < utftext.length) {

                c = utftext.charCodeAt(i);

                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }

            }

            return string;
        }

    };

    criptRede(text: string, cript: boolean): string {

        let result ='';

        if (cript) {
            let min = Math.ceil(0);
            let max = Math.floor(90);
            let vId = Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and     
            let vCt = 0;
            for (let i in text.split('')) {
                vCt++;
                let char = text[i];
                result = result + String.fromCharCode(char.charCodeAt(0) + (vId + Math.floor(vCt / 2)));
            }
            result = this.base64.encode(String.fromCharCode(vId+5) + result);
        }

        if (!cript) {

            text = this.base64.decode(text);
            let vId = text[0].charCodeAt(0)-5;
            text = text.substring(1, text.length);

            let vCt = 0;
            for (let i in text.split('')) {
                vCt++;
                let char = text[i];
                result = result + String.fromCharCode(char.charCodeAt(0) - (vId + Math.floor(vCt / 2)));
                
            }

        }

        console.log(result);
        return result;
    }

    //#MIGRATE
    plural(qtde: number, text: string, many: string = '', zero: string = ''): string {

        if (!qtde && zero == null) return '';
        if (!qtde && zero) return zero;

        let padrao = text + (qtde <= 1 ? '' : 's');
        let textor = (qtde > 1 && many ? many : padrao);
        return Intl.NumberFormat('pt-BR').format(qtde) + ' ' + textor;

    }

    //#MIGRATE
    concat(array: any[], space: string = ' '): string {

        let result = '';
        array.forEach(text => result += (!text ? '' : (result == '' ? '' : space) + text));
        return result;

    }

    level0(array: Array<any>, keys: Array<any>): any {

        if (array.length != 1) return null;

        let object = array[0];
        for (let index in keys) {
            if (object[keys[index]].length != 1) return null;
            object = object[keys[index]][0];
        }

        return object;

    }

    invert(value, taga, tagb): any {

        return (value == taga ? tagb : taga);

    }

    //#MIGRATE
    filterArray(filtred, terms): Array<any> {

        if (!terms) return this.deepCopy(filtred[0].array);

        //Exato: Bittencourt Gabriel (acha resultado)
        let result: any[] = [];
        /*
                let array = this.deepCopy(filtred[0].array);
                array.forEach((root, index) => {

                    filtred.forEach(filter => {

                        let bool = this.filterSearch(false, root, terms, filter.field, filter.types);
                        if (!bool) {
                            console.log(root.NegocioNome, index);
                            arriy.splice(index, 1)
                        }

                    });

                });
                console.log('Finded...', result);
        */

        let array = this.deepCopy(filtred[0].array);
        array.forEach((root) => {

            let copy = this.deepCopy(root);
            copy.Brandeds = [];

            root.Brandeds.forEach(branded => {

                let bool = this.filterSearch(false, branded, terms, ['BrandedID', 'BrandedNome', 'BrandedNick', 'BrandedSame'], ['int', 'str', 'str', 'str']);
                
                if (branded.BrandedSpots) {
                    if (!bool) bool = (branded.BrandedSpots.findIndex(HS => HS.HotspotID == parseInt(terms)) >= 0);
                    if (!bool) bool = (branded.BrandedSpots.findIndex(HS => HS.EmpresaRnid == terms) >= 0);
                }

                if (bool) copy.Brandeds.push(branded);

            });

            if (copy.Brandeds.length) result.push(copy);

        });

        return result;

    }

    //#MIGRATE
    filterSearch(bool, lino, termns, fields, intstr): boolean {

        if (!termns) return bool;
        termns = termns.toLowerCase().split(' ');

        termns.forEach(termn => {

            fields.forEach((named, index) => {

                let item = (lino[named] || '');
                let string = this.removerAcentos(item.toString().toLowerCase());

                if (intstr[index] == 'int' && string == termn) bool = true;
                if (intstr[index] == 'str' && string.indexOf(termn) >= 0) bool = true;

            });

        });

        return bool;

    }

    //#MIGRATE
    impact(tipo: 'impact' | 'success' | 'selection' = 'impact') {

        if (!this.nativeApp()) return;

        if (tipo == 'impact')    this.taptic.impact({style: 'heavy'});
        if (tipo == 'success')   this.taptic.notification({type: 'success'});
        if (tipo == 'selection') this.taptic.selection();

    }

    //#MIGRATE
    vibrate(time, times: boolean = false) {

        if (!this.nativeApp()) return;

        if (!times) {
            this.vibration.vibrate(time);
            return;
        }

        setTimeout(() => this.vibration.vibrate(10), 0);
        setTimeout(() => this.vibration.vibrate(20), 600);
        setTimeout(() => this.vibration.vibrate(30), 1200);

    }

    //#MIGRATE
    realConnection(): Observable<any> {

        /*
        {"as":"AS262659 ULTRAWAVE TELECOM EIRELI",
        "city":"Bauru",
        "country":"Brazil",
        "countryCode":"BR",
        "isp":"Ultrawave Telecom Eireli",
        "lat":-22.3239,
        "lon":-49.078,
        "org":"Ultrawave Telecom Eireli",
        "query":"179.127.59.190",
        "region":"SP",
        "regionName":"Sao Paulo",
        "status":"success",
        "timezone":"America/Sao_Paulo",
        "zip":""}
        */
        let url = 'http://www.ip-api.com/json';
        return this.http.get(url, {}, true);


        // IPREAL - Esse outro link retorna o IP REAL, se quiser desenvolver na bridge da para retornar
        // https://api.ipify.org/?format=json

    }

    ipClass(ip: string, classe: string = '10.0.0.') {

        return (ip.indexOf(classe) >= 0);

    }

    arrayShuffle(array) {

        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;

    }

    //#MIGRATE - (NOVO colocar no NODE)
    arraySort(array, field, sortby : 'date' | 'int' = 'int') {

        return array.sort((n1,n2) => {
        
            if (sortby === 'date') {
                return n1[field] - n2[field];
            }
            
            if (sortby === 'int') {
                if (n1[field] > n2[field])  return 1;
                if (n1[field] < n2[field])  return -1;
                if (n1[field] == n2[field]) return 0;
            }

        });

    }

    randomize(bool: boolean = true): any {

        let value = Math.random();
        return (bool ? (value > 0.5) : value);

    }

    //#MIGRATE
    private _jsFor(js: any, chaves: string[] | number[] = [], tipo: TJSFor, selected: string = '', selectValue: any[] = null, selectLevel: number = -1, actualLevel: number = -1, actualValor: any = null): any {

        if (!js) {
            return (tipo == TJSFor.jsForCat ? '' : 0);
        }

        // array for -> navegação automática
        if (js instanceof Array && typeof chaves[0] == 'string') {

            if (tipo == TJSFor.jsForMin) {
                let resultMin = 0;
                js.forEach(item => {
                    let valor = this._jsFor(item, chaves, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);
                    resultMin = (resultMin != 0 && resultMin <= valor ? resultMin : valor);
                });

                return resultMin;
            }

            if (tipo == TJSFor.jsForMax) {
                let resultMax = 0;
                js.forEach(item => {
                    let valor = this._jsFor(item, chaves, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);
                    resultMax = (resultMax != 0 && resultMax >= valor ? resultMax : valor);
                });

                return resultMax;
            }

            if (tipo == TJSFor.jsForSum) {

                let resultSum = 0;

                actualLevel++;

                js.forEach(item => {

                    let allowSum = (selectValue == null && item[selected]) || (selectValue && selectValue.indexOf(item[selected]) >= 0);
                    if (selectLevel == actualLevel && !allowSum) return;
                    resultSum += this._jsFor(item, chaves, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);

                });

                return resultSum;
            }

            if (tipo == TJSFor.jsForCat) {
                let resultCat = '';
                js.forEach((item, index) => {
                    if (index > 0) resultCat += '#!#!';
                    resultCat += this._jsFor(item, chaves, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);
                });

                return resultCat;
            }

            if (tipo == TJSFor.jsForCount) {
                let resultCat = 0;
                js.forEach(item => {
                    resultCat += this._jsFor(item, chaves, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);
                });

                return resultCat;
            }

        }

        // último item -> soma
        if (chaves.length == 1) {

            let keyValue = js[chaves[0]];
            let nilValue = (tipo == TJSFor.jsForCat ? '': 0);

            // se não existir a prop. retorna nada
            if (!keyValue) return nilValue;

            let result = (tipo == TJSFor.jsForCount ? 1 : (tipo == TJSFor.jsForCat ? keyValue : <number>keyValue));

            actualLevel++;
            
            let allowSum = (selectValue == null && js[selected]) || (selectValue && selectValue.indexOf(js[selected]) >= 0);
            if (selectLevel == actualLevel && !allowSum) result = nilValue;

            //if (tipo == TJSFor.jsForSum) console.log('result-obj: ' + JSON.stringify(js), selected, selectValue, js[selected]);
            
            return result;

        }

        // object -> navegação
        let chavesShift = this.deepCopy(chaves);
        return this._jsFor(js[chavesShift.shift()], chavesShift, tipo, selected, selectValue, selectLevel, actualLevel, actualValor);

    }

    //#MIGRATE
    jsMin(js: any, chaves: string[] | number[] = [], selected: string = '', selectValue: any[] = null, selectLevel: number = -1): number {

        if (selected && selectLevel == -1) selectLevel = chaves.length - 1;

        return <number>this._jsFor(js, chaves, TJSFor.jsForMin, selected, selectValue, selectLevel);

    }

    //#MIGRATE
    jsMax(js: any, chaves: string[] | number[] = [], selected: string = '', selectValue: any[] = null, selectLevel: number = -1): number {

        if (selected && selectLevel == -1) selectLevel = chaves.length - 1;

        return <number>this._jsFor(js, chaves, TJSFor.jsForMax, selected, selectValue, selectLevel);

    }

    //#MIGRATE
    jsSum(js: any, chaves: string[] | number[] = [], selected: string = '', selectValue: any[] = null, selectLevel: number = -1): number {

        if (selected && selectLevel == -1) selectLevel = chaves.length - 1;

        return <number>this._jsFor(js, chaves, TJSFor.jsForSum, selected, selectValue, selectLevel);

    }

    //#MIGRATE
    jsCat(js: any, chaves: string[] | number[] = [], selected: string = '', selectValue: any[] = null, selectLevel: number = -1, separa: string = ', ', nenhum: string = ''): string {

        if (selected && selectLevel == -1) selectLevel = chaves.length - 1;

        let result = <string>this._jsFor(js, chaves, TJSFor.jsForCat, selected, selectValue, selectLevel);

        if (!result) result = nenhum;
        if (result) {
            let array = result.split('#!#!');
            result = array.join(separa);
        }

        return result;

    }

    //#MIGRATE
    jsCount(js: any, chaves: string[] | number[] = [], selected: string = '', selectValue: any[] = null, selectLevel: number = -1): number {

        if (selected && selectLevel == -1) selectLevel = chaves.length - 1;

        return <number>this._jsFor(js, chaves, TJSFor.jsForCount, selected, selectValue, selectLevel);

    }

    //#MIGRATE
    jsTrim(js: any, chaves: string[]): string {

        chaves.forEach(value => {
            if (js) js = js[value];
        });

        return ((!js || js == 0 || js == null) ? '' : js.toString().trim());

    }

    jsLoop(js: any) {

        let result = [];
        Object.keys(js).forEach((key) => result.push({field: key, value: js[key]}));
        return result;

    }

    // #JSON.parse precisa do try catch para nao dar pal
    jsParse(text) {

        try { 
            return JSON.parse(text) 
        }
        catch (erro) { 
            return null;
        };

    }

    ngZonerun() {

        //APP-PUBLISH - IONIC 4 precisa de ngZone?

        //COM CHANGEDETECTOR
        //public changeDetectorRef: ChangeDetectorRef       //no Constructor
        //changeDetection: ChangeDetectionStrategy.OnPush   //no Decorate OnPush funciona como NGZONE
        //this.ref.markForCheck();

        //COM NGZONE
        //public ngZone: NgZone                             //no Constructor
        //this.ngZone.run();

    }

    versionText(version: string, release: TVersionText = TVersionText.vtFull, fonetica: number = -1): string {

        return version;

    }

    nativeApp(platformName: string = '') {

        return (this.platform.is('cordova') && !this.platform.is('core') && !this.platform.is('mobileweb')) && (!platformName || this.platform.is(platformName));

    }

    browserApp(platformName: string = '', mobileOnly: boolean = true) {

        return (!mobileOnly && this.platform.is('core')) || ((this.platform.is('mobileweb')) && (!platformName || this.platform.is(platformName)));

    }

    downloadApp(platformName: string = '') {

        return (!this.nativeApp() && !this.browserApp()) || (!this.nativeApp() && this.browserApp(platformName));

    }

    programExit() {

        this.platform.exitApp();
        
    }

    develop() {

        // IonicApp = 127.0.0.1
        // IonicDev = localhost (ionic serve -b)
        let addressAll = window.location.hostname;
        let addressDot = window.location.hostname.substr(0, 7);
        return (addressAll == 'localhost' || addressDot == '10.0.0.' || addressDot == '172.20.10.');

    }

    deviceSystem() {

        if (this.nativeApp()) {

            if (this.platform.is('ios'))          return TDevicerBios.dbIos;
            else if (this.platform.is('android')) return TDevicerBios.dbAndroid;
            else if (this.platform.is('windows')) return TDevicerBios.dbWindows;
            else if (this.platform.is('linux'))   return TDevicerBios.dbLinux;
            else                                  return TDevicerBios.dbNone;

        } else {

            if (this.deviceService.getDeviceInfo().os == 'mac')          return TDevicerBios.dbIos;
            else if (this.deviceService.getDeviceInfo().os == 'android') return TDevicerBios.dbAndroid;
            else if (this.deviceService.getDeviceInfo().os == 'windows') return TDevicerBios.dbWindows;
            else if (this.deviceService.getDeviceInfo().os == 'linux')   return TDevicerBios.dbLinux;
            else                                                         return TDevicerBios.dbNone;

        }

    }

    deviceSerial(data?): string {

        // Acesso Web-Cria uma Serial Virtual para o "dispositivo" ou melhor browser aberto
        
        // Grava na memoria a sessão
        // para nao ficar pegando do BD toda hora.
        if (data) this.dataService.set('BROWSER-SERIAL', data);
        return this.dataService.get('BROWSER-SERIAL');

    }

    deviceInfo(): Observable<any> {

        return Observable.create((observer) => {

            let devicerBios = this.deviceSystem();

            // apps compilados
            if (this.nativeApp()) {

                // pega dados do App do hotspot via BundleID
                this.appVersion.getPackageName()
                    .then(bundle => {

                        let data = {
                            DevicerBios: devicerBios,
                            DevicerFrom: TDevicerFrom.dfMobile,
                            DevicerHttp: TDevicerHttp.dhApp,
                            DevicerFirm: this.device.version,
                            DevicerSoft: CONFIG.data.version,
                            DevicerHard: this.device.model,
                            DevicerHash: this.device.uuid,
                            DevicerNome: (window as any).device.name, //EXCLUIR ? Nao esta gravando pois não vem mais!
                            DevicerPush: '', //(!this.registrationPush ? '' : this.registrationPush.registrationId),
                            DeviceBundle: bundle,
                            DeviceDomain: window.location.hostname.replace('www.', ''),
                        };

                        observer.next(data);
                        observer.complete();

                    })
                    .catch((erro) => {

                        observer.error(erro);
                        observer.complete();

                    });

            } else {

                let userAgent = '';
                let userArray = this.deviceService.getDeviceInfo().userAgent.split(' ');
                let userAchou = false;

                for (let a in userArray) {
                    if (userAchou) {
                        userAgent = userArray[a].replace('_', '.');
                        break;
                    }

                    if (devicerBios == TDevicerBios.dbIos  && userArray[a] == 'OS')         userAchou = true;
                    if (devicerBios == TDevicerBios.dbAndroid && userArray[a] == 'Android') userAchou = true;
                }

                let devicerFirm = this.deviceService.getDeviceInfo().os_version.split('-')[1];
                devicerFirm = (typeof devicerFirm != 'undefined' ? devicerFirm : userAgent);
                if (devicerFirm) devicerFirm = devicerFirm.replace('_', '.');

                let data = {
                    DevicerBios: devicerBios,
                    DevicerFrom: (this.deviceService.isMobile() || this.deviceService.isTablet() ? TDevicerFrom.dfMobile : (this.deviceService.isDesktop() ? TDevicerFrom.dfDesktop : TDevicerFrom.dfNone)),
                    DevicerHttp: TDevicerHttp.dhWeb,
                    DevicerFirm: devicerFirm,
                    DevicerSoft: CONFIG.data.version,
                    DevicerHard: this.deviceService.getDeviceInfo().os,
                    DevicerHash: this.deviceSerial(),
                    DevicerNome: 'Browser Web', //cordova.plugins.deviceName, //EXCLUIR ? Nao esta gravando pois não vem mais!
                    DevicerPush: '', //(!this.registrationPush ? '' : this.registrationPush.registrationId),
                    DeviceBundle: '',
                    DeviceDomain: window.location.hostname.replace('www.', ''),
                };

                observer.next(data);
                observer.complete();

            }
        })
    }

    baixarApp() {

        let url = '';

        let devicerBios = this.deviceSystem();
        if (devicerBios == TDevicerBios.dbIos) url = CONFIG.paths.appStoreLink;
        if (devicerBios == TDevicerBios.dbAndroid) url = CONFIG.paths.playStoreLink;

        let buttons = [];
                 buttons.push({text: (url ? 'Agora não' : 'Ok'), handler: () => {}});
        if (url) buttons.push({text: 'Baixar', handler: () => this.open(url, '_blank')});

        this.alertSimply('Você poderá ver os lugares que seus amigos estão, visualizar e pagar sua comanda, ver seus check-ins e muito mais!', 'Baixe o aplicativo :)');

    }

    googleCreate(googleaid: string) {

        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date().getTime();
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        window['ga'] = <any>window['ga'];
        window['ga']('create', googleaid, 'auto');
        //window['ga']('send', 'pageview');
    }

    googleAnalytic(hitType: TGoogleAnalytic, title: string, page: string) {

        if (typeof window['ga'] == 'undefined') return;

        let type = (hitType == TGoogleAnalytic.gaPageview ? 'pageview' : 'pageview');

        let data = {
            hitType: type,
            title: title,
            page: page
        };

        window['ga']('send', data);
    }

    //#MIGRATE
    paramParse(key?): any {

        let query = window.location.pathname.substring(1);
        let vars = query.split('/');

        let params: Array<string> = [];
        for (let i in vars) {
            params.push(decodeURIComponent(vars[i]));
        }

        if (typeof key == 'undefined') {
            return params;
        } else {
            if (typeof params[key] == 'undefined') {
                return null;
            } else {
                return params[key];
            }
        }

    }

    //#MIGRATE
    queryParse(queryString?, key?): any {

        queryString = (!queryString || queryString.indexOf('?') == 0 ? '' : '?') + queryString;

        let query = queryString.split('?').reverse()[0];
        let vars = query.split('&');

        let params: any = {};
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }

        if (typeof key == 'undefined') {
            return params;
        } else {
            if (typeof params[key] == 'undefined') {
                return null;
            } else {
                return params[key];
            }
        }

    }

    showRemove(itemSlide: ItemSliding, event) {

        event.stopPropagation();

        itemSlide.startSliding(0);
        itemSlide.moveSliding(-120);
        setTimeout(() => {
            itemSlide.moveSliding(-120);
            itemSlide.endSliding(0.3); // you can mock anything less than 0.3
        }, 100);

    }

    keygambTime(): boolean {

        if (!this.platform.is('mobile')) return false;

        let opened = this.keyboard.isOpen();
        if (opened && !this.isKeyboard) this.isKeyboard = true;
        if (this.isKeyboard != opened) setTimeout(() => this.isKeyboard = opened, 600);
        //if (this.isKeyboard != opened) this.isKeyboard = opened;

        return this.isKeyboard;

    }

    slideNext(that: any, bool: boolean): boolean {

        if (bool) that.slideNext();
        return bool;

    }

    manutencao(perfil, text): boolean {

        if (perfil.Profile.ProfileTeam < TProfileTeam.mkManager) {
            this.toastSimply(text);
            //return true;
        }

        return false;

    }

    //#MIGRATE
    loadingDots(texto: string = null) {

        let objectShow = (texto ? {content: texto} : {cssClass: 'loading-no-bg', spinner: 'dots'});
        return this.loadingCtrl.create(objectShow);
    }

    //#MIGRATE
    toastSimply(text, time: number = 3000, handler = () => {
    }) {

        if (!text) return;

        this.toastCtrl.create({
            message: text,
            duration: time,
            position: 'top',
            showCloseButton: true,
            closeButtonText: 'OK',
        }).present();

        if (handler) handler();

    }

    //#MIGRATE
    alertSimply(text, title: string = 'OPS!', button: string = 'Ok', alertDanger: boolean = false, cssClass: any = null, handler = () => {
    },) {

        if (!text) return;

        this.alertCtrl.create({
            title: title,
            message: text,
            cssClass: (cssClass ? cssClass : (alertDanger ? 'alert-danger alert-big' : 'alert-alert')),
            buttons: [{text: button, handler: handler}]
        }).present();

    }

    //#MIGRATE
    alertPopula(erro, root, copy, handler = () => {}) {

        this.populateObj(copy, root);
        this.alertResult(erro, handler);

    }

    //#MIGRATE
    alertResult(erro, handler = () => {}) {

        if (!erro) return;
        if (!erro.Titulo && !erro.Result && !erro.Alerta) return;

        if (!erro.Titulo) erro.Titulo = 'Atenção';

        this.alertCtrl.create({
            title: erro.Titulo,
            message: (!erro.Result ? erro.Alerta : erro.Result),
            buttons: [{text: 'Ok', handler: handler}]
        }).present();

    }

    //#MIGRATE
    alertQuestion(title: string = 'ATENÇÃO', alerta: string, sim: string = 'Continuar', handler = () => {
    }, forceTrue: boolean = false, alertDanger: boolean = false, cssClass: any = null, handlerCancel = () => {
    }) {

        if (forceTrue) {
            handler();
            return;
        }

        if (!alerta) return;

        let array = (sim.split('|'));
        if (array.length == 1) array.push('Cancelar');

        let buttons: Array<any> = [];
        buttons.push({text: array[1], hole: 'cancel', handler: handlerCancel});
        buttons.push({text: array[0], handler: handler});

        this.alertCtrl.create({
            title: title,
            message: alerta,
            cssClass: (cssClass ? cssClass : (alertDanger ? 'alert-danger alert-big' : 'alert-alert')),
            buttons: buttons
        }).present();

    }

    //#MIGRATE
    alertObserv(title: string, alerta: string, sim: string = 'Continuar', forceTrue: boolean = false, modalAlert: TModalAlert = TModalAlert.maAlert, executObserv: Observable<any> = null): Observable<any> {

        let resultObserv = Observable.create((observer: Observer<any>) => {

            // ***** QUESTION-NAO ***** //
            if (forceTrue) {

                //Observable nao
                if (!executObserv) {

                    observer.next({});
                    observer.complete();

                    return
                }

                //Observable sim
                let loading = this.loadingDots();
                loading.present();
                executObserv
                    .finally(() => loading.dismiss())
                    .subscribe(
                        (data) => {

                            observer.next(data);
                            observer.complete();

                        },
                        (erro) => {

                            observer.error(erro);
                            observer.complete();

                        });

                return;
            }

            // ***** QUESTION-YES ***** //
            let buttons: Array<any> = [];

            buttons.push({
                text: 'Cancelar', hole: 'cancel',
                handler: () => {
                    observer.error({});
                    observer.complete();
                }
            });

            buttons.push({
                text: sim,
                handler: () => {

                    //Observable nao
                    if (!executObserv) {

                        observer.next({});
                        observer.complete();

                        return
                    }

                    //Observable sim
                    let loading = this.loadingDots();
                    loading.present();
                    executObserv
                        .finally(() => loading.dismiss())
                        .subscribe(
                            (data) => {

                                observer.next(data);
                                observer.complete();

                            },
                            (erro) => {

                                observer.error(erro);
                                observer.complete();

                            });

                }
            });

            this.alertCtrl.create({
                title: title,
                message: alerta,
                cssClass: (modalAlert == TModalAlert.maDanger ? 'alert-danger alert-big' : (modalAlert == TModalAlert.maAlert ? 'alert-alert' : '')),
                buttons: buttons
            }).present();

        });

        return resultObserv;
    }

    modalopen(component: any, size: 'wide' | 'quad' | 'high' | 'full' | 'alto', round: boolean, data: any = null, present: any = null, forceOpts: any = null, willDismiss: Function = null, onThen: Function = null, backdrop: boolean = false): Observable<any> {

        return Observable.create(observer => {

            if (!data) data = {};
            data.pagecut = round;

            if (!present) present = {};

            let roundtxt = 'modal-margin modal-margin-round';

            let objectOpts = {};
            if (size == 'wide') objectOpts = {
                enableBackdropDismiss: backdrop,
                backdropDismiss: backdrop,
                cssClass: (!round ? '' : roundtxt)
            };
            if (size == 'quad') objectOpts = {
                enableBackdropDismiss: backdrop,
                backdropDismiss: backdrop,
                cssClass: 'modal-quad' + (!round ? '' : ' ' + roundtxt)
            };
            if (size == 'high') objectOpts = {
                enableBackdropDismiss: backdrop,
                backdropDismiss: backdrop,
                cssClass: 'modal-high' + (!round ? '' : ' ' + roundtxt)
            };
            if (size == 'full') objectOpts = {
                enableBackdropDismiss: backdrop,
                backdropDismiss: backdrop,
                cssClass: 'modal-full' + (!round ? '' : ' ' + roundtxt)
            };
            if (size == 'alto') objectOpts = {
                enableBackdropDismiss: backdrop,
                backdropDismiss: backdrop,
                cssClass: 'modal-alto' + (!round ? '' : ' ' + roundtxt)
            };
            if (forceOpts) objectOpts = forceOpts;

            let modal = this.modalCtrl.create(component, data, objectOpts);
            modal.onWillDismiss(data => {
                if (willDismiss) willDismiss(data);
            });
            modal.onDidDismiss(data => {
                if (data) observer.next(data);
                observer.complete();
            });
            modal.present(present).then(() => {
                if (onThen) onThen();
            });

        });

    }

    //#MIGRATE
    sheetClass(value: any = true, check: any = true, color: 'roxa' | 'food' | 'lime' | 'dash' = 'roxa'): string {

        return value != check ? null : 'action-sheet-' + color;

    }

    //#MIGRATE
    sheetOpen(buttons: Array<any>, title: string, one: number = 1, exec: number = 0) {

        if (!buttons || !buttons.length) return;

        /** OPEN **/
        let sheet = {title: title, buttons: buttons};
        if (buttons.length <= one) buttons[exec].handler();
        if (buttons.length != one) this.actionSheetCtrl.create(sheet).present();

    }

    //#MIGRATE
    pickerOpen(columns: Array<any>, onExec: Function, onExit: Function = null, onChange: Function = null, one: number = 1, exec: number = 0, separa: string = null) {

        let onDone = (done) => {

            if (done == null) {
                if (onExit) onExit();
                return;
            }

            let root = (done.root ? done.root.value : 0);
            let ruut = (done.ruut ? done.ruut.value : 0);
            let reet = (done.reet ? done.reet.value : 0);
            onExec(root, ruut, reet);

        };

        if (separa) {
            let backup = this.deepCopy(columns[1]);
            columns.splice(1, 1);

            let lines: Array<any> = [];
            lines.push({text: separa, value: 0});
            columns.push({name: 'text', options: lines});
            columns.push(backup);
        }

        let buttons: Array<any> = [];
        buttons.push({text: 'Cancel', role: 'cancel', handler: () => onDone(null)});
        buttons.push({text: 'Pronto', handler: (done) => onDone(done)});

        let picker = this.pickerCtrl.create({
            columns: columns,
            buttons: buttons,
        });

        if (onChange) picker.ionChange.subscribe(event => onChange(picker, event));

        /*
                    let onMove = (picker, event) => {

                        if (picker.columns[0].selectedIndex == 1) {
                            let newpush: Array<any> = [];
                            newpush.push({text: 'A', value: 0});
                            newpush.push({text: 'B', value: 1});
                            newpush.push({text: 'C', value: 2});
                            picker.getColumn('reet').selectedIndex = 0;
                            picker.getColumn('reet').prevSelected = 0;
                            picker.getColumn('reet').options = newpush;
                            picker.refresh();

                            setTimeout(() => {
                                picker.instance._cols.toArray().forEach((col) => {
                                    col.lastIndex = 0;
                                    col.selectedIndex = 0;
                                    col.prevSelected = null;
                                    //col.setSelected(1, 100);
                                    //col.refresh();
                                });
                            }, 50)
                        }

                        picker.columns[1] = columns;

                    };
            */

        picker.present();

    }

    pickerHoip(hoip: string, onExec: Function) {

        let onDone = (done) => {

            if (done == null) {
                if (onExec) onExec(null);
                return;
            }

            onExec(done.box1.value + '.' + done.box2.value + '.' + done.box3.value + '.' + done.box4.value);

        };

        let zero255 = [];
        for (let i = 0; i < 255; i++) zero255.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'box1', options: zero255});
        columns.push({name: 'box2', options: zero255});
        columns.push({name: 'box3', options: zero255});
        columns.push({name: 'box4', options: zero255});

        let buttons: Array<any> = [];
        buttons.push({text: 'Cancel', role: 'cancel', handler: () => onDone(null)});
        buttons.push({text: 'Pronto', handler: (done) => onDone(done)});

        let picker = this.pickerCtrl.create({
            columns: columns,
            buttons: buttons,
        });

        picker.getColumn('box1').selectedIndex = parseInt(hoip.split('.')[0]);
        picker.getColumn('box2').selectedIndex = parseInt(hoip.split('.')[1]);
        picker.getColumn('box3').selectedIndex = parseInt(hoip.split('.')[2]);
        picker.getColumn('box4').selectedIndex = parseInt(hoip.split('.')[3]);

        picker.present();

    }

    //#MIGRATE
    pickerCash(min, max, cent, cash, onSave: Function, extra?, noMoney?) {

        let onDone = (root, ruut) => {
            let value = parseFloat(root + '.' + ruut);
            onSave(value, extra);
        };


        /** OPEN **/
        let columns = [];

        let buttons: Array<any> = [];
        for (let i = min; i <= max; i++) buttons.push({text: (noMoney ? '': 'R$ ') + i, value: i});
        columns.push({name: 'root', options: buttons, columnWidth: '70px', align: 'right'});
        columns[0].selectedIndex = parseInt((cash + '').split('.')[0]);

        let linus: Array<any> = [];
        linus.push({text: ',', value: 0});
        columns.push({name: 'text', options: linus, columnWidth: '5px'});

        let buttuns: Array<any> = [];
        if (!cent) buttuns.push({text: '00', value: '00'});
        if (cent) for (let i = 0; i <= 99; i = i + cent) buttuns.push({
            text: (i <= 9 ? '0' : '') + i,
            value: (i <= 9 ? '0' : '') + i,
        });
        columns.push({name: 'ruut', options: buttuns, columnWidth: '35px', align: 'left'});
        columns[2].selectedIndex = parseInt((cash + '').split('.')[1]);

        this.pickerOpen(columns, onDone);

    }

    //#MIGRATE
    pickerCent(min, max, more, index, onSave: Function, extra?) {

        let onDone = (root, ruut) => {
            let value = parseInt(root);
            onSave(value, extra);
        };


        /** OPEN **/
        let columns = [];

        let buttons: Array<any> = [];
        for (let i = min; i <= max; i = i + more) buttons.push({text: i + '%', value: i});
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = index;

        this.pickerOpen(columns, onDone);

    }

    inumArray(length: number): any {

        let array = [];
        for (let i = 0; i < length; i++) array.push(i + 1);
        return array;

    }

    //#MIGRATE
    enumArray(enumerator, mini: number = 0, maxi: number = 0, difere: number = 0): any {

        let array = Object.keys(enumerator).filter(key => !isNaN(Number(enumerator[key])));
        array = array.filter((key, idx) => (idx >= mini) && (!maxi || idx <= maxi) && (!difere || idx != difere));
        return array;

    }

    //#MIGRATE
    enunArray(enumerator, mini: number = 0, maxi: number = 0, difere: number = 0): any {

        let array = Object.keys(enumerator).filter(key => isNaN(Number(enumerator[key])));
        array = array.filter((key, idx) => (idx >= mini) && (!maxi || idx <= maxi) && (!difere || idx != difere));
        return array;

    }

    //#MIGRATE
    enumStart(choosetype: TChooseType, enumerator: any, enumsize: number, fieldname: string, fieldsize, selected: number, that: any, start: number = 0, extra?, namefix?) {

        //Wheel só funciona no nativeApp
        if (!this.nativeApp() && choosetype == TChooseType.ctWheel) choosetype = TChooseType.ctSheet;

        let buttons: Array<any> = [];

        let arrayEnum = this.enumArray(enumerator);
        arrayEnum.forEach((flag, index) => {

            if (index >= start) {
                let texto = (namefix ? namefix[index] : flag.slice(enumsize, 99));
                let click = () => that.enumClick(enumerator, fieldname, flag, that, extra);
                let style = this.sheetClass(selected, index);

                /** SAIR **/
                //Esse se clica fora ele cria a requisicao mesmo assim!
                //if (choosetype == TChooseType.ctSheet) buttons.push({text: 'Cancelar', role: 'cancel', handler: click});


                if (choosetype == TChooseType.ctSheet) buttons.push({text: texto, cssClass: style, handler: click});
                if (choosetype == TChooseType.ctWheel) buttons.push({description: flag.slice(enumsize, 99)});
            }

        });


        /** OPEN **/
        let title = fieldname.slice(fieldsize, 99);


        /** OPEN SHEET **/
        if (choosetype == TChooseType.ctSheet) {
            let sheet = {title: title, buttons: buttons};
            this.actionSheetCtrl.create(sheet).present();
        }


        /** OPEN WHEEL **/
        if (choosetype == TChooseType.ctWheel) {
            let check = {index: selected, value: enumerator[selected]};
            let wheel = {
                title: title,
                items: [buttons],
                negativeButtonText: "Cancelar",
                positiveButtonText: "Alterar",
                defaultItems: [check]
            };
            this.wheelSelector.show(wheel).then(
                data => that.enumClick(enumerator, fieldname, data[0].description, that, extra),
                erro => console.log('Wheel Error: ', erro)
            );
        }

    }

    //#MIGRATE
    arrayStart(choosetype, title, arrayValue, arrayTexto, fieldname, selected: number = 0, that: any, start: number = 0, extra?, role: '' | 'destructive' | 'cancel' = '') {

        //Wheel só funciona no nativeApp
        if (!this.nativeApp() && choosetype == TChooseType.ctWheel) choosetype = TChooseType.ctSheet;


        let buttons: Array<any> = [];

        arrayValue.forEach((flag, index) => {

            if (index >= start) {
                let texto = (arrayTexto == null ? flag : arrayTexto[index]);
                let click = () => that.arrayClick(fieldname, flag, that, extra);
                let style = (index == selected || flag == selected ? 'action-sheet-roxa' : null);

                if (choosetype == TChooseType.ctSheet) buttons.push({
                    text: texto,
                    role: (index != arrayValue.length - 1 ? '' : role),
                    cssClass: style,
                    handler: click
                });
                if (choosetype == TChooseType.ctWheel) buttons.push({description: texto});
            }

        });


        /** OPEN SHEET **/
        if (choosetype == TChooseType.ctSheet) {
            let sheet = {title: title, buttons: buttons};
            this.actionSheetCtrl.create(sheet).present();
        }


        /** OPEN WHEEL **/ /*
        if (choosetype == TChooseType.ctWheel) {
            let check = {index: selected, value: selected};
            let wheel = {title: title, items: [buttons], negativeButtonText: "Cancelar", positiveButtonText: "Alterar", defaultItems: [check]};
            this.wheelSelector.show(wheel).then(
                data => that.arrayClick(fieldname, data[0].description, that, extra),
                erro => console.log('Wheel Error: ', erro)
            );
        }
*/
    }

    arrayLoop(pos: 'NEXT' | 'BACK', array: any, index: number, field: string, notIqual: boolean = false) {

        let result = null;

        if (pos == 'NEXT' && array.length > index + 1) result = array[index + 1];
        if (pos == 'BACK' && array.length > index + 0) result = array[index + 0];

        if (result && field) result = result[field];
        if (notIqual && result == array[index][field]) result = '';

        return result;

    }

    colorOlha(color: string): string {

        let cormilk = (CONFIG.negative(color) == 'CorMilk');
        return (cormilk ? 'CorLime' : 'CorRoxa');

    }

    stylesBarOnoff(bool: boolean) {

        if (!this.nativeApp()) return;

        if ( bool) this.statusBar.show();
        if (!bool) this.statusBar.hide();

        //* iOS note: you must call StatusBar.overlaysWebView(false) to enable color changing with this.statusBar.backgroundColorByHexString
        this.statusBar.overlaysWebView(bool);

    }

    stylesBarColor(color: string) {

        let cormilk = (CONFIG.negative(color) == 'CorMilk');
        return (cormilk ? TStatusBar.sbStyleLightContent : TStatusBar.sbStyleDefault);

    }

    statusBarColor(style: TStatusBar, backup: boolean = true, color: string = '') {


        if (!this.nativeApp()) return;

        //if (this.websterOpen) style = TStatusBar.sbStyleLightContent;

        if (backup && style != TStatusBar.sbBackupRestore) this.backpColorbar = style;

        switch (style) {
            case TStatusBar.sbStyleDefault:
                this.statusBar.styleDefault();
                this.statusBar.backgroundColorByHexString(CONFIG.colors[color] || CONFIG.colors.CorMilk);
                break;

            case TStatusBar.sbStyleLightContent:
                this.statusBar.styleLightContent();
                this.statusBar.backgroundColorByHexString(CONFIG.colors[color] || CONFIG.colors.CorMenu);
                break;

            case TStatusBar.sbBackupRestore:
                this.statusBarColor(this.backpColorbar);
                break;
        }

    }

    // não faz o pop da atual, funciona para limpar o histórico
    // por isso não usa o navCtrl.popTo()
    // todo: jogar para navRepository
    dismissToViewName(navCtrl: NavController, viewName: string, closeSelf: boolean = false): boolean { //: Observable<any>

        //APP-PUBLISH - Parar e trocar tudo que nao deveria usar .map para ForEach
        let start = 0;
        let totalRemove = 0;

        navCtrl.getViews().map((view) => {

            if (view.name == viewName) {

                //console.log(view.name, view.index);
                totalRemove = 0;
                start = view.index;

            } else {

                totalRemove++;

            }

        });


        if (totalRemove > 0) {
            //console.log('VIEWS:', navCtrl.getViews(), start, totalRemove);
            navCtrl.remove(start, totalRemove + (closeSelf ? 1 : 0), {animate: false});
        }

        return (totalRemove > 0);

    }

    isRoot(): boolean {

        if (!this.app.getRootNavs()[0] || !this.app.getRootNavs()[0].getActiveChildNavs()[0]) return true;

        let array = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs();
        if (array.length) return (array[0].getViews().length == 1);

        return true;

    }

    navRoot(navCtrl: NavController) {

        setTimeout(() => this.pageroot = !navCtrl.canGoBack(), 1000);

    }

    navActive(navCtrl: any = null): any {

        if (!this.app.getRootNavs()[0] || !this.app.getRootNavs()[0].getActiveChildNavs()[0]) {
            return navCtrl;
        }

        let array = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs();
        if (array.length) return array[0];

        return navCtrl;

    }

    navOpened(navCtrl: NavController, viewName: string): boolean {

        return !!navCtrl.getViews().filter(view => view.name == viewName).length;
    }

    open(url, target, html?) {

        let win = window.open(url, target);

        if (html) {
            win.document.body.innerHTML = html;
            //win.document.html = html;
        }

    }

    fullScreen() {

        let dcmt = <any>document;

        // check if user allows full screen of elements. This can be enabled or disabled in browser config. By default its enabled.
        //its also used to check if browser supports full screen api.
        if ("fullscreenEnabled" in dcmt || "webkitFullscreenEnabled" in dcmt || "mozFullScreenEnabled" in dcmt || "msFullscreenEnabled" in dcmt) {
            if (dcmt.fullscreenEnabled || dcmt.webkitFullscreenEnabled || dcmt.mozFullScreenEnabled || dcmt.msFullscreenEnabled) {

                let element = dcmt.getElementsByTagName('ion-app')[0];
                //requestFullscreen is used to display an element in full screen mode.
                if ("requestFullscreen" in element) {
                    element.requestFullscreen();
                } else if ("webkitRequestFullscreen" in element) {
                    element.webkitRequestFullscreen();
                } else if ("mozRequestFullScreen" in element) {
                    element.mozRequestFullScreen();
                } else if ("msRequestFullscreen" in element) {
                    element.msRequestFullscreen();
                }

            }
        }
    }

    screenChange() {

        let dcmt = <any>document;

        //fullscreenElement is assigned to html element if any element is in full screen mode.
        if (dcmt.fullscreenElement || dcmt.webkitFullscreenElement || dcmt.mozFullScreenElement || dcmt.msFullscreenElement) {
            //console.log("Current full screen element is : " + (dcmt.fullscreenElement || dcmt.webkitFullscreenElement || dcmt.mozFullScreenElement || dcmt.msFullscreenElement))
        } else {
            // exitFullscreen us used to exit full screen manually
            if ("exitFullscreen" in dcmt) {
                dcmt.exitFullscreen();
            } else if ("webkitExitFullscreen" in dcmt) {
                dcmt.webkitExitFullscreen();
            } else if ("mozCancelFullScreen" in dcmt) {
                dcmt.mozCancelFullScreen();
            } else if ("msExitFullscreen" in dcmt) {
                dcmt.msExitFullscreen();
            }
        }
    }

    anyParams(valor: any, value: any, valuo: any = null, valuu: any = null): any {

        return (valuu ? valuu : (valuo ? valuo : (value ? value : valor)));

    }

    textReplace(str, from, to) {

        let protectionLimit = 200;

        while (str.indexOf(from) !== -1 && protectionLimit > 0) {
            str = str.replace(from, to);
            protectionLimit--;
        }

        return str;

    }

    removerAcentos(newStringComAcento: string) {
        let string = newStringComAcento;
        let mapaAcentosHex = {
            a: /[\xE0-\xE6]/g,
            A: /[\xC0-\xC6]/g,
            e: /[\xE8-\xEB]/g,
            E: /[\xC8-\xCB]/g,
            i: /[\xEC-\xEF]/g,
            I: /[\xCC-\xCF]/g,
            o: /[\xF2-\xF6]/g,
            O: /[\xD2-\xD6]/g,
            u: /[\xF9-\xFC]/g,
            U: /[\xD9-\xDC]/g,
            c: /\xE7/g,
            C: /\xC7/g,
            n: /\xF1/g,
            N: /\xD1/g,
        };

        for (let letra in mapaAcentosHex) {
            let expressaoRegular = mapaAcentosHex[letra];
            string = string.replace(expressaoRegular, letra);
        }

        return string;
    }

    //#MIGRATE
    clipboardCopy(textcopy : string, toastText: string = 'Copiado para clipboard', onOk?, OnErr?) {

        try {
            var textArea = document.createElement("textarea");
    
            textArea.style.position = 'fixed';
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = "0";
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = textcopy;
            document.body.appendChild(textArea);
            textArea.select();

            try {
              var successful = document.execCommand('copy');
              
            } catch (err) {
                toastText = 'Oops, erro ao copiar';
            }
            document.body.removeChild(textArea);
    

            if (successful) {
                !onOk || onOk();
                this.toastSimply(toastText);
            }

            if (!successful) {
                !OnErr || OnErr();
            }

        } catch (erro) {
            !OnErr || OnErr();
        }
        
    }

    

    //#MIGRATE
    nomeFirst(nome) {

        return (!nome ? '' : nome.split(' ')[0]);

    }

    //#MIGRATE
    nomeLast(nome) {

        return (!nome ? '' : nome.split(' ')[1]);

    }

    //#MIGRATE
    nomeCorta(nome: string, upperCase: boolean = false) {

        let ct: number;
        let result = nome.substr(0, nome.indexOf(' '));

        if (result == '') {
            result = nome;
        } else {
            for (ct = nome.length - 1; ct >= 0; ct--) {
                if (nome[ct] == ' ') {
                    result = result + nome.substr(ct);
                    break;
                }
            }
        }

        if (upperCase) {
            result = result.toUpperCase();
        }

        return result;

    }

    //#MIGRATE
    nomeSigla(nome) {

        let corta = this.nomeCorta(nome).split(' ');
        return (corta[0][0] + (corta[1] ? corta[1][0] : corta[0][0])).toUpperCase();

    }

    //#MIGRATE
    birthday(born: string): boolean {

        //fazer teste de dia para saber se esta na semana do aniversario
        //this.datePart();

        return false;

    }

    brasilIbge(city, tipo: 'BR' | 'UF'): TFederalIbge {

        let estado = city.substring(0, 2);
        if (['AM', 'PA', 'RR', 'AP', 'RO', 'AC', 'TO'].indexOf(estado) >= 0) return TFederalIbge.fiNorte;
        if (['PI', 'MA', 'PE', 'RN', 'PB', 'CE', 'BA', 'AL', 'SE'].indexOf(estado) >= 0) return TFederalIbge.fiNordeste;
        if (['MT', 'MS', 'GO', 'DF'].indexOf(estado) >= 0) return TFederalIbge.fiCentro;
        if (['SP', 'RJ', 'MG', 'ES'].indexOf(estado) >= 0) return TFederalIbge.fiSudeste;
        if (['PR', 'RS', 'SC'].indexOf(estado) >= 0) return TFederalIbge.fiSul;

        return TFederalIbge.fiNone;

    }

    timeOnly(date: any, segundo: boolean = false, separa: ':' | 'h' = 'h'): string {

        let data = (date ? new Date(date) : new Date())
        // let dia = data.getDate().toString().padStart(2, '0')
        // let mes = (data.getMonth() + 1).toString().padStart(2, '0') //+1 pois no getMonth Janeiro começa com zero.
        // let ano = data.getFullYear()

        let hora = data.getHours().toString().padStart(2, '0')
        let minu = data.getMinutes().toString().padStart(2, '0')
        let seco = data.getSeconds().toString().padStart(2, '0')

        return (hora + separa + minu) + (segundo ? ':' + seco : '');

    }

    horatime(date: any, segundo: boolean = false, separa: ':' | 'h' = 'h'): string {

        if (!date) return '';

        date = date.replace('  ', ' ').split(' ');
        let hour = (date[1] ? date[1] : '00:00:00').split(':');

        return hour[0] + separa + hour[1] + (segundo ? ':' + hour[2] : '');

    }

    weekBetween(dateBetween): boolean {

        dateBetween = new Date(dateBetween);//.toUTCString();

        var data = new Date()

        // O primeiro dia é o dia do mês, menos o dia da semana
        var primeiro = data.getDate() - data.getDay() + 1; 
        
        let primeiroDia = new Date(data.setDate(primeiro));//.toUTCString();
        let ultimoDia = new Date(data.setDate(data.getDate()+6));//.toUTCString();

        // console.log(primeiroDia)
        // console.log(ultimoDia)
        // console.log(dateBetween)
        // console.log((dateBetween >= primeiroDia && dateBetween <= ultimoDia));
        return (dateBetween >= primeiroDia && dateBetween <= ultimoDia);

    }

    strToData(date: any): string {

        if (!date) return '';

        date = date.replace('  ', ' ').split(' ');
        let hour = (date[1] ? date[1] : '00:00:00').split(':');

        date = date[0].split('/');
        return date[2] + '-' + date[1] + '-' + date[0] + ' ' + hour[0] + ':' + hour[1] + ':' + (hour[2] ? hour[2] : '00')

    }

    //#MIGRATE
    dateHoje(): Date {

        return new Date();

    }

    //#MIGRATE
    datePart(mini, maxi, week: boolean = false): any {

        if (maxi == null) maxi = this.dateToStr();

        if (mini > maxi) {
            let aux = maxi;
            maxi = mini;
            mini = aux;
        }

        let sete = (this.dateDias(mini, maxi) > 7);
        mini = this.strToDate(mini, mini.split(' ')[1]);
        maxi = this.strToDate(maxi, maxi.split(' ')[1]);

        let delta = Math.abs(maxi - mini) / 1000;
        let result = {};

        let struct = {
            year: 31536000,
            month: 2592000,     // Comenta ele ignora e soma no de baixo
            week: 604800,       // Uncomment row to ignore
            day: 86400,
            hour: 3600,
            minute: 60,
            second: 1
        };


        if (week) delete struct.month;
        if (sete) delete struct.day;


        Object.keys(struct).forEach(function (key) {
            result[key] = Math.floor(delta / struct[key]);
            delta -= result[key] * struct[key];
        });

        // for example: {year:0,month:0,week:1,day:2,hour:34,minute:56,second:7}

        return result;

    }

    //#MIGRATE
    dateText(mini, maxi: string = null, text: null | 'first' | 'small' = null, week: boolean = true, hojeOnte: boolean = false, agora: number = 5): string {

        if (!mini) return 'nunca';
        if (mini == 'CURRENT_DATE') mini = this.dateToStr(null, false);
        if (mini == 'CURRENT_TIMESTAMP') mini = this.dateToStr(null, true);

        let result = '';
        let detail = this.datePart(mini, maxi, week);

        //HOJE | ONTEM
        if (hojeOnte) {
            let hoje = (!detail.year && !detail.month && detail.day == 0 && detail.hour < 24);
            let onte = (!detail.year && !detail.month && detail.day == 1 && detail.hour < 24);
            if (hoje) return 'Hoje';
            if (onte) return 'Ontem';
        }

        if (text == 'small') {
            if (detail.year)   return detail.year   + 'a';
            if (detail.month)  return detail.month  + 'm';
            if (detail.week)   return detail.week   + 'w';
            if (detail.day)    return detail.day    + 'd';
            if (detail.hour)   return detail.hour   + 'h';
            if (detail.minute) return detail.minute + '`';
            if (detail.second) return detail.second + '``';
            return '';
        }

        //DATA
        let e: string = (detail.year == 0 && detail.month == 0) ? '' : 'e ';
        if (detail.year) result += ' ' + this.plural(detail.year, 'Ano');
        if (detail.month) result += ' ' + this.plural(detail.month, 'Mes', 'Meses');
        if (detail.day) result += ' ' + e + this.plural(detail.day, 'Dia');

        //WEEK
        if (result == '') {
            if (detail.week) result += ' ' + this.plural(detail.week, 'Semana');
        }

        //TIME
        if (result == '') {

            //AGORA
            if (agora > 0 && detail.minute < agora && !detail.hour) return 'Agora';

            if (detail.hour) result += ' ' + this.plural(detail.hour, 'Hora');
            if (detail.minute) result += ' ' + this.plural(detail.hour, 'Minuto');
            if (detail.second) result += ' ' + this.plural(detail.hour, 'Segundo');
        }

        //TRIM
        if (result) result = result.trim();
        if (result) result = result.replace('  ', ' ').replace('  ', ' ').replace('  ', ' ');

        //FIRST - Pega primeiro ex: 9 Meses, ignora resto
        if (text == 'first') {
            let splite = result.split(' ');
            return splite[0] + ' ' + splite[1];
        }

        return result;

    }

    //#MIGRATE
    dateDias(mini, maxi?): number {

        if (!mini) mini = this.dateToStr(null);
        if (!maxi) maxi = this.dateToStr(null);

        mini = new Date(mini);
        maxi = new Date(maxi);
        return Math.round((maxi - mini) / (1000 * 60 * 60 * 24));

        //let max: Date = new Date(final);
        //let min: Date = new Date(inicial);
        //return Math.round((max - min)/(1000*60*60*24));

    }

    dateToStr(date: Date = null, hour: boolean = false, formatBR: boolean = false): string {

        let data = (date ? date : new Date())
        let dia = data.getDate().toString().padStart(2, '0')
        let mes = (data.getMonth() + 1).toString().padStart(2, '0') //+1 pois no getMonth Janeiro começa com zero.
        let ano = data.getFullYear()

        let hora = data.getHours().toString().padStart(2, '0')
        let minu = data.getMinutes().toString().padStart(2, '0')
        let seco = data.getSeconds().toString().padStart(2, '0')

        let time = (!hour ? '' : ' ' + hora + ':' + minu + ':' + seco);

        if (!formatBR) return ano + '-' + mes + '-' + dia + time;
        if ( formatBR) return dia + '/' + mes + '/' + ano + time;

    }

    strToDate(date, hour?): Date {

        if (!date) return null;

        date = date.split(' ')[0].split('-');

        //MERDA - Data com 2 anos coloca 2000 Ex.: 18-01-01 = 2018-01-01
        date[0] = date[0].length == 2 ? '20' + date[0] : date[0];

        //MERDA - Ele comeca os meses no 00 até 11 e não 01 até 12
        //if (date[1] == '00')
        date[1] = date[1] - 1;

        hour = (hour ? hour : '00:00:00').split(':');

        return new Date(date[0], date[1], date[2], hour[0], hour[1], hour[2] ? hour[2] : '00');

    }

    //#MIGRATE
    roundUp(value: number, digit: number = 2): number {

        if (digit == 0) return Math.ceil(value);
        if (digit == 1) return Math.ceil(value * 10) / 10;
        if (digit == 2) return Math.ceil(value * 100) / 100;
        if (digit == 3) return Math.ceil(value * 1000) / 1000;

        return 0;
    }

    //#MIGRATE
    diaFirst(date: any): Date {

        if (!date) date = new Date;
        return new Date(date.getFullYear(), date.getMonth(), 1);

    }

    //#MIGRATE
    diaLast(date: any = null, sumMes: number = 0): Date {

        if (!date) date = new Date;

        date.setMonth(date.getMonth() + sumMes);
        let dateLast = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        return new Date(date.getFullYear(), date.getMonth(), dateLast.getDate());

    }

    //#MIGRATE
    dateLast(date: string): string {

        //Corrige Lastday Exemplo: vem 2021-02-31 troca para 2021-02-28
        let array = date.split('-');
        let lasti = new Date(parseInt(array[0]), parseInt(array[1]), 0);
        let troca = this.dateToStr(lasti);
        if (parseInt(array[2]) > parseInt(troca.split('-')[2])) date = troca;

        return date;

    }

    dataft(dateStr: string, dia: null | 'dd' = 'dd', mes: null | 'num' | 'char' | 'full' = 'char', ano: null | 'yy' | 'yyyy' = 'yyyy', separa: '/' | ' ' = ' '): string {

        if (dateStr == 'CURRENT_DATE') dateStr = this.dateToStr(null, false);
        if (dateStr == 'CURRENT_TIMESTAMP') dateStr = this.dateToStr(null, true);

        //Gambi quando vem "YYYY-MM" exemplo: "2019-09", adiciono dia "01"
        if (dateStr && dateStr.length == 7) dateStr = dateStr + '-01';

        //if (dateStr) dateStr = dateStr.replace(/\s+/g, 'T');
        if (dateStr) dateStr = dateStr[5] + dateStr[6] + '/' + dateStr[8] + dateStr[9] + '/' + dateStr[0] + dateStr[1] + dateStr[2] + dateStr[3];

        let date = new Date(dateStr);
        if (!date || !dateStr) return '';

        let result = '';
        let mun = date.getMonth() + 1;

        let mon = ("0" + mun).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);

        if (dia == 'dd') result += day + (!mon && !ano ? '' : separa);
        if (mes == 'num') result += mon + (!ano ? '' : separa);
        if (mes == 'char') result += TMonth[mun].slice(2, 5).toUpperCase() + (!ano ? '' : separa);
        if (mes == 'full') result += TMonth[mun].slice(2, 99) + (!ano ? '' : separa);
        if (ano == 'yy') result += (date.getFullYear() + '').slice(2, 4);
        if (ano == 'yyyy') result += date.getFullYear();

        return result.trim();
    }

    semana(dateStr: string, tresChar: boolean = false, upperLower: TUpperLowerCase = TUpperLowerCase.ulNormal) {

        return this._mesSemana('weekday', dateStr, tresChar, upperLower).split('-')[0];

    }

    mes(dateStr: string, tresChar: boolean = false, upperLower: TUpperLowerCase = TUpperLowerCase.ulNormal) {

        return this._mesSemana('month', dateStr, tresChar, upperLower);

    }

    ano(date: any): number {

        if (!date) date = new Date;
        if (date) date = new Date(date);

        return date.getFullYear();

    }

    mesano(date: any) {

        if (!date) date = new Date;
        if (date) date = new Date(date);

        return TMonth[date.getMonth() + 1].slice(2, 5).toUpperCase() + '/' + date.getFullYear();

    }

    private _mesSemana(prop: string, dateStr: string, tresChar: boolean = false, upperLower: TUpperLowerCase = TUpperLowerCase.ulNormal) {

        if (!dateStr) {
            return '';
        }

        let opt: Intl.DateTimeFormatOptions = prop == 'month' ? {month: tresChar ? 'short' : 'long'} : {weekday: tresChar ? 'short' : 'long'};
        let retStr = new Date(dateStr).toLocaleString('pt-br', opt);

        retStr = retStr.charAt(0).toUpperCase() + retStr.slice(1).split('.')[0];

        retStr = upperLower == TUpperLowerCase.ulUpper ? retStr.toUpperCase() : retStr;
        return upperLower == TUpperLowerCase.ulLower ? retStr.toLowerCase() : retStr;

    }

    //#MIGRATE
    profileAged(born: string, text: null | 'anos' | 'years' = 'anos') {

        let d = new Date,
            hoje_ano = d.getFullYear(),
            hoje_mes = d.getMonth() + 1,
            hoje_dia = d.getDate(),

            born_ano2: any = +this.strToDate(born).getFullYear(),
            born_mes2: any = +this.strToDate(born).getMonth() + 1,
            born_dia2: any = +this.strToDate(born).getDate(),

            idade = hoje_ano - born_ano2;

        if (hoje_mes < born_mes2 || hoje_mes == born_mes2 && hoje_dia < born_dia2) idade--;

        idade = (idade < 0 ? 0 : idade);
        return text ? (idade + ' ' + text) : idade;

    }

    tracerRota(lat1, lon1, lat2 , lon2): number {

        /*
        let d2r = 0.017453292519943295769236;

        let dlong = (lon2 - lon1) * d2r;
        let dlat = (lat2 - lat1) * d2r;

        let temp_sin = sin(dlat/2.0);
        let temp_cos = cos(lat1 * d2r);
        let temp_sin2 = sin(dlong/2.0);

        let a = (temp_sin * temp_sin) + (temp_cos * temp_cos) * (temp_sin2 * temp_sin2);
        let c = 2.0 * atan2(sqrt(a), sqrt(1.0 - a));

        return 6368.1 * c;
        */

        return 0;

    }

    formatRota(rota: number): string {

        if (!rota) return '';
        //return rota < 1 ? FormatFloat('00', rota * 1000) + ' metros' : FormatFloat('0.0', rota) + ' km');

    }

    //#MIGRATE
    formatByte(byte: number): string {

        let result: string = '';

        if (byte > 1) result = (byte).toFixed(1) + ' BY';
        if (byte / 1024 > 1) result = (byte / 1024).toFixed(1) + ' KB';
        if (byte / 1024 / 1024 > 1) result = (byte / 1024 / 1024).toFixed(1) + ' MB';
        if (byte / 1024 / 1024 / 1024 > 1) result = (byte / 1024 / 1024 / 1024).toFixed(1) + ' GB';
        if (byte / 1024 / 1024 / 1024 / 1024 > 1) result = (byte / 1024 / 1024 / 1024 / 1024).toFixed(1) + ' TB';

        if (result) result.replace('.', ',');
        return result;
    }

    formatDOC(rnid): string {

        if (rnid) rnid = rnid.replace(/[^\d]+/g, '');
        if (rnid.length == 11 && this.validaCNPF(rnid)) return rnid[0] + rnid[1] + rnid[2] + '.' + rnid[3] + rnid[4] + rnid[5] + '.' + rnid[6] + rnid[7] + rnid[8] + '-' + rnid[9] + rnid[10];
        if (rnid.length == 14 && this.validaCNPJ(rnid)) return rnid[0] + rnid[1] + '.' + rnid[2] + rnid[3] + rnid[4] + '.' + rnid[5] + rnid[6] + rnid[7] + '/' + rnid[8] + rnid[9] + rnid[10] + rnid[11] + '-' + rnid[12] + rnid[13];

        return ''

    }

    traduzDOC(doc): string {

        if (!doc) return 'Documento';

        let size = doc.replace(/[^\d]+/g, '');

        if (size.length == 11 || (doc.length > 3 && doc[3] == '.')) return 'CPF';
        if (size.length == 14 || (doc.length > 2 && doc[2] == '.')) return 'CNPJ';

        return 'Documento';

    }

    validaRnid(rnid, blankTrue: boolean = false) {

        return (this.validaCNPF(rnid, blankTrue)) || (this.validaCNPJ(rnid, blankTrue));

    }

    validaCNPJ(documento, blankTrue: boolean = false) {

        if (documento) documento = documento.replace(/[^\d]+/g, '');
        if (!documento) return blankTrue;
        if (documento.length != 14) return false;


        // documento invalidos conhecidos
        if (documento == '00000000000099') return true;
        if (documento == "00000000000000" || documento == "11111111111111" || documento == "22222222222222" || documento == "33333333333333" || documento == "44444444444444" ||
            documento == "55555555555555" || documento == "66666666666666" || documento == "77777777777777" || documento == "88888888888888" || documento == "99999999999999")
            return false;

        // Valida DVs
        let tamanho = documento.length - 2;
        let numeros = documento.substring(0, tamanho);
        let digitos = documento.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) return false;

        tamanho = tamanho + 1;
        numeros = documento.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        return (resultado == digitos.charAt(1));

    }

    validaCNPF(documento, blankTrue: boolean = false) {

        if (documento) documento = documento.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        if (documento) documento = documento.replace('.', '').replace('.', '').replace('.', '').replace('.', '');
        if (!documento) return blankTrue;
        if (documento.length < 11) return false;


        // documento invalidos conhecidos
        if (documento == '00000000099') return true;
        if (documento == '00000000000' || documento == '11111111111' || documento == '22222222222' || documento == '33333333333' || documento == '44444444444' ||
            documento == '55555555555' || documento == '66666666666' || documento == '77777777777' || documento == '88888888888' || documento == '99999999999')
            return false;

        let numeros, digitos, soma, i, resultado, digitos_iguais;
        digitos_iguais = 1;

        for (i = 0; i < documento.length - 1; i++) {
            if (documento.charAt(i) != documento.charAt(i + 1)) {
                digitos_iguais = 0;
                break;
            }
        }

        if (!digitos_iguais) {
            numeros = documento.substring(0, 9);
            digitos = documento.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

            if (resultado != digitos.charAt(0)) return false;

            numeros = documento.substring(0, 10);
            soma = 0;
            for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

            return resultado == digitos.charAt(1);
        }

        return false;
    }

    //valida data - dd/mm/aaaa
    validaData(data) {

        if (!data) return false;

        let day = data.substring(0, 2);
        let month = data.substring(3, 5);
        let year = data.substring(6, 10);
        let yearof = (new Date()).getFullYear();

        //MERDA - Data com 2 anos coloca 2000 Ex.: 01/01/18 = 01/01/2018
        year = parseInt((year.length == 2 ? '20' : '') + year);

        if (year < yearof - 90 || year > yearof + 5) return false;

        else if (month > 12) return false;

        //months 31 days
        else if ((month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) && (day < 1 || day > 31)) return false;

        //months 30 days
        else if ((month == 4 || month == 6 || month == 9 || month == 11) && (day < 1 || day > 30)) return false;

        //February and leap year
        else if (month == 2) {
            if (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)) {
                if (day < 1 || day > 29) return false;
            } else {
                if (day < 1 || day > 28) return false;
            }
        }

        return true;

    }

    validaEmail(email: string): boolean {
        let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }

    validaCartao(cardNumber, cardType) {

        cardNumber = cardNumber.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '');
        cardNumber = cardNumber.replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '').replace(' ', '');
        const ccCheckRegExp = /[^\d ]/;
        let isValid = !ccCheckRegExp.test(cardNumber);
        let cardNumberLength;
        let cardNumbersOnly;
        if (isValid) {
            cardNumbersOnly = cardNumber.replace(/ /g, "");
            cardNumberLength = cardNumbersOnly.length;
            let lengthIsValid = false;
            let prefixRegExp;
            switch (cardType) {
                case "mastercard":
                    lengthIsValid = (cardNumberLength == 16);
                    prefixRegExp = /^5[1-5]/;
                    break;
                case "visa":
                    lengthIsValid = (cardNumberLength == 16 || cardNumberLength == 13);
                    prefixRegExp = /^4/;
                    break;
                case "diners":
                case "elo":
                    return true; // sem validação
                case "amex":
                    lengthIsValid = (cardNumberLength == 15);
                    prefixRegExp = /^3(4|7)/;
                    break;
                default:
                    prefixRegExp = /^$/;
                    return false;
            }

            let prefixIsValid = prefixRegExp.test(cardNumbersOnly);
            isValid = prefixIsValid && lengthIsValid;
        }
        if (isValid) {
            let numberProduct;
            //var numberProductDigitIndex;
            let checkSumTotal = 0;
            let digitCounter;
            for (digitCounter = cardNumberLength - 1; digitCounter >= 0; digitCounter--) {
                checkSumTotal += parseInt(cardNumbersOnly.charAt(digitCounter));
                digitCounter--;
                numberProduct = String((cardNumbersOnly.charAt(digitCounter) * 2));
                for (let productDigitCounter = 0; productDigitCounter < numberProduct.length; productDigitCounter++) {
                    checkSumTotal += parseInt(numberProduct.charAt(productDigitCounter));
                }
            }
            isValid = (checkSumTotal % 10 == 0);
        }

        return isValid;
    }

    plasticAlert(plastic: any, safe: boolean): string {

        let valilife = plastic.PlasticLife + (plastic.PlasticLife && plastic.PlasticLife.length == 7 ? '-01' : '');
        let validade = this.strToDate(valilife);
        let validate = (this.diaLast(validade) >= this.diaLast(new Date));

        if (!plastic.Methodo)     return 'Informe a Bandeira';
        if (!plastic.PlasticCard) return 'Informe o Número do cartão';
        if (!plastic.PlasticNome) return 'Informe o Titular';
        if (!plastic.PlasticRnid) return 'CPF não informado';
        if (!plastic.PlasticLife) return 'Informe a Validade';
        if ( plastic.PlasticLife && !validate) return 'Cartão está vencido';
        if ( plastic.PlasticSafe != TPlasticSafe.psSafe && safe && plastic.PlasticID) return 'Autentique seu cartão';
        return '';

    }

    //#MIGRATE
    clearObj(json, ignore: string[] = [], populate: any = null) {

        for (let a in json) {

            if (ignore.indexOf(a) >= 0) continue;

            //if (typeof json[a] == 'object') {
            //    this.clearObj(json[a]);
            //}
            //else {
            delete json[a];
            //}
        }

        if (populate) this.populateObj(json, populate);

    }

    //#MIGRATE
    populateObj(objReceive, objSend, ignore: string[] = [], nulles: boolean = false, create: boolean = true) {

        for (let a in objSend) {

            //Array
            if (objSend[a] instanceof Array) {
                if (!objReceive.hasOwnProperty(a)) objReceive[a] = [];
                this.populateObj(objReceive[a], objSend[a], [], nulles);
                continue;
            }

            //Object
            if (objSend[a] instanceof Object) {
          //if (typeof objSend[a] == 'object')
          //Assim se quiser popular por exemplo uma classe, "create class Perfil" nao é mais um object "puro"!

                if (objSend[a] == null && nulles) objReceive[a] = null;

                let exist = (objReceive[a] == null || !objReceive.hasOwnProperty(a));
                if (exist) objReceive[a] = (objSend[a] == null ? null : {});

                this.populateObj(objReceive[a], objSend[a], [], nulles);
                continue;
            }

            //Function
            if (objSend[a] instanceof Function) {

                //alert('Function');

            }

            //Ignore
            if (ignore.indexOf(a) >= 0) {
                continue;
            }

            //Define
            objReceive[a] = objSend[a];

        }

    }

    //#MIGRATE
    deepCopy(json: any, jNull?) {

        if (json == null && jNull) return jNull;

        if (json == null || typeof json != 'object') return json;

        return JSON.parse(JSON.stringify(json));

    }

    //#MIGRATE
    shallowCopy(json: any) {

        if (json == null || 'object' != typeof json) return json;

        const copy = json.constructor();
        for (const attr in json) {
            if (json.hasOwnProperty(attr)) copy[attr] = json[attr];
        }

        return copy;

    }

    isArray(json): boolean {

        return (json instanceof Array);

    }

    rule3(valor1: number, para1: number, valor2: number, arredonda: boolean = false, max100 : boolean = false, comparativo : boolean = false): number {

        try {

            if (valor1 == 0) return 0;
            let result = (para1 * valor2) / valor1;

            if (arredonda) result = Math.round(result);
            if (!arredonda) result = parseFloat(result.toFixed(2));

            if (result>para1 && max100) result = para1;
            else if (comparativo) result = para1 - result;

            return result;

        } catch (erro) {

            return 0;

        }

    }

    currency(value): number {

        if (!value || typeof value == 'undefined') return 0;

        if (typeof value == 'string') return parseFloat(value.replace('R$ ', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
        return value;

    }

    parcelar(cash, qtde): string {

        return qtde + 'x • ' + this.dinheiro(this.roundUp(cash / qtde));

    }

    //#MIGRATE
    numerico(value, minLength: number = 0): string {

        if ((value + '').length <= minLength) return value;

        if (isNaN(value)) value = 0;
        return new Intl.NumberFormat('pt-BR').format(value);

    }

    isNumber(value): boolean {

        return !isNaN(value);

    }

    barcode(value): string {

        if (isNaN(value)) value = '';
        if (value.length == 8)  return value.substring(0, 4) + ' ' + value.substring(4, 8);
        if (value.length == 12) return value.substring(0, 1) + ' ' + value.substring(1, 6) + ' ' + value.substring(6, 11) + ' ' + value.substring(11, 12);
        if (value.length == 13) return value.substring(0, 1) + ' ' + value.substring(1, 7) + ' ' + value.substring(7, 13);
        if (value.length == 14) return value.substring(0, 1) + ' ' + value.substring(1, 3) + ' ' + value.substring(3, 8) + ' ' + value.substring(8, 13) + ' ' + value.substring(13, 14);

    }

    porcenta(value, digts: number = 0): string {

        if (isNaN(value)) value = 0;
        return parseFloat('' + value.toFixed(digts)) + '%';

    }

    dinheiro(value, cents: boolean = true, semMoeda: boolean = false): string {

        if (typeof value == 'string') {
            return '' + parseFloat(value.replace('R$ ', '').replace('.', '').replace(',', '.'));
        }

        let x = 0;
        if (value < 0) {
            value = Math.abs(value);
            x = 1;
        }

        let valueTxt: string;
        if (isNaN(value)) value = 0;
        let cent: any = Math.floor((value * 100 + 0.5) % 100);
        valueTxt = Math.floor((value * 100 + 0.5) / 100).toString();

        if (cent < 10) cent = "0" + cent;
        for (let i = 0; i < Math.floor((valueTxt.length - (1 + i)) / 3); i++) {
            valueTxt = valueTxt.substring(0, valueTxt.length - (4 * i + 3)) + '.' + valueTxt.substring(valueTxt.length - (4 * i + 3));
        }

        let ret = valueTxt + (!cents ? '' : ',' + cent);
        if (x == 1) ret = '-' + ret;

        return (semMoeda ? '' : 'R$ ') + ret;
    }

    returnFalse() {
        //EXCLUIR - O QUE É ISSO MIDUKAN?
        return false;
    }

    //#MIGRATE
    monitorDesk(monitorBool: boolean, document, hotspotID, params, action?, json?, timeout?, monitorHoip?) : Observable<any> {

        if (!action) action = TAction.acLoad;

        let timeoutDesk = CONFIG.request.totalTimeout;
        if (monitorBool) {
            let akkjson = (window as any).handappMainInstance.appjson;
            if (!monitorHoip && akkjson.hotwork) monitorHoip = akkjson.hotwork.Hotspot.HotspotHoip;
            if (monitorHoip) {
                timeoutDesk = timeout || 5000;
                document = 'http://' + monitorHoip + ':8855/' + document;
            }
        }

        let url = document + '?Action=' + TAction[action] + '&HotspotID=' + hotspotID + params;

        if (!json) {
            return this.http.get(url, {}, false, timeoutDesk);
        }

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon, {}, false, timeoutDesk);
        }

    }

    machineHard(cmd: 'desligarLedStatus' | 'ligarLedStatus' | 'imprimir' | 'acionarGuilhotina', param) : Observable<any> {

        let url = 'http://127.0.0.1:5000/' + (cmd == 'imprimir' || cmd == 'acionarGuilhotina' ? 'printer' : 'led');

        const headers= new HttpHeaders()
          .set('Content-Type', 'application/json');
          
        let dataJSon = {CMD: cmd, PARAM: param};
        return this.http.post(url, dataJSon, {headers: headers}, false);

    }

    getimg(url: string): Observable<any> {

      //return this.http.get(url, {responseType: 'blob'}, false)
        return this.http.get(url, {responseType: 'text'}, false)
            .map(data => {
                return data;
            });

    }

    getog(url: string): Observable<any> {

        //#CAP-MDK //MDK

        return this.http.get(url, {responseType: 'text'}, false)
            .map(data => {
console.log(url, data);
                let el = document.createElement('html');
                el.innerHTML = data;
                let metas = el.getElementsByTagName('meta');
console.log(url, metas);
                let ogData = {};

                for (let a in metas) {
                    if (a !== 'item' && typeof metas[a] == 'object' && typeof metas[a].getAttribute !== 'undefined') {
                        if (metas[a].getAttribute("property") && metas[a].getAttribute("property").substr(0, 3) == 'og:') {
                            ogData[metas[a].getAttribute("property").substr(3)] = metas[a].getAttribute("content");
                        }
                    }
                }
console.log(ogData);
                if (!ogData || !ogData['image']) throw {Title: 'Ops!', Result: 'OG não processado.'};

                return ogData;

            });

    }

    filenameExt(name): TFileType {

        //let re = /(?:\.([^.]+))?$/;
        //let ext = re.exec(name)[1];
        let ext = name.split('.').pop();
        if (ext) ext = ext.toLowerCase();

        if (ext == 'exe') return TFileType.ftExe;
        if (ext == 'txt') return TFileType.ftTxt;
        if (ext == 'csv') return TFileType.ftCsv;
        if (ext == 'sql') return TFileType.ftSql;
        if (ext == 'son') return TFileType.ftSon;
        if (ext == 'xml') return TFileType.ftXml;
        if (ext == 'pdf') return TFileType.ftPdf;
        if (ext == 'png') return TFileType.ftPng;
        if (ext == 'jpg') return TFileType.ftJpg;
        if (ext == 'jpeg') return TFileType.ftJpg;
        if (ext == 'mp3') return TFileType.ftMp3;
        if (ext == 'mp4') return TFileType.ftMp4;
        if (ext == 'swf') return TFileType.ftSwf;

        return TFileType.ftNao;

    }

    fileTipo(file: TFileType): TFileTipo {

        if (file == TFileType.ftExe) return TFileTipo.ftTipos;
        if (file == TFileType.ftTxt) return TFileTipo.ftTexto;
        if (file == TFileType.ftCsv) return TFileTipo.ftTexto;
        if (file == TFileType.ftSql) return TFileTipo.ftTexto;
        if (file == TFileType.ftSon) return TFileTipo.ftTexto;
        if (file == TFileType.ftXml) return TFileTipo.ftTexto;
        if (file == TFileType.ftPdf) return TFileTipo.ftTexto;
        if (file == TFileType.ftPng) return TFileTipo.ftImage;
        if (file == TFileType.ftJpg) return TFileTipo.ftImage;
        if (file == TFileType.ftMp3) return TFileTipo.ftAudio;
        if (file == TFileType.ftMp4) return TFileTipo.ftVideo;
        if (file == TFileType.ftYou) return TFileTipo.ftVideo;
        if (file == TFileType.ftSwf) return TFileTipo.ftVideo;
        //ftNao

        return TFileTipo.ftTipos;
    }

    fileType(mime: string): TFileType {

        if (!mime) return TFileType.ftNao;

        //Se veio "https://storage.bridge.com.br/profile/00000000/ghost.png?nocache=99999"
        //console.log(mime, mime.substr(0, 5));
        if (mime.substr(0, 5) == 'https') {
            mime = mime.split('?')[0];
            mime = mime.split('.').reverse()[0];
            if (mime.length == 3) {
                mime = 'ft' + mime[0].toUpperCase() + mime[1].toLowerCase() + mime[2].toLowerCase();
                return TFileType[mime];
            }
        }

        //Se veio "data:image/png;base64,XXXXXX"
        if (mime.substr(0, 5) == 'data:') {
            mime = mime.split(':')[1];
            mime = mime.split(';')[0];
        }

        if (mime == 'application/octet-stream') return TFileType.ftExe;
        if (mime == 'text/plain') return TFileType.ftTxt;
        if (mime == 'text/csv') return TFileType.ftCsv;
        if (mime == 'text/plain') return TFileType.ftSql;
        if (mime == 'text/plain') return TFileType.ftSon;
        if (mime == 'text/xml') return TFileType.ftXml;
        if (mime == 'application/xml') return TFileType.ftXml;
        if (mime == 'application/pdf') return TFileType.ftPdf;
        if (mime == 'image/png') return TFileType.ftPng;
        if (mime == 'image/jpg') return TFileType.ftJpg;
        if (mime == 'image/jpeg') return TFileType.ftJpg;
        if (mime == 'audio/mp3') return TFileType.ftMp3;
        if (mime == 'video/mp4') return TFileType.ftMp4;
        if (mime == 'application/x-shockwave-flash') return TFileType.ftSwf;

        return TFileType.ftNao;
    }

    mimeType(file: TFileType): string {

        if (!file) return '';

        if (file == TFileType.ftExe) return 'application/octet-stream';
        if (file == TFileType.ftTxt) return 'text/plain';
        if (file == TFileType.ftCsv) return 'text/csv';
        if (file == TFileType.ftSql) return 'text/plain';
        if (file == TFileType.ftSon) return 'text/plain';
        if (file == TFileType.ftXml) return 'text/xml';
        if (file == TFileType.ftPdf) return 'text/pdf';
        if (file == TFileType.ftPng) return 'image/png';
        if (file == TFileType.ftJpg) return 'image/jpeg';
        if (file == TFileType.ftMp3) return 'audio/mp3';
        if (file == TFileType.ftMp4) return 'audio/mp4';
        if (file == TFileType.ftSwf) return 'application/x-shockwave-flash';

        return '';
    }

    mimeAllow(source: string, allow: string) {

        return (!source || allow.indexOf(source.substr(5, 10)) >= 0 || allow.indexOf(source.substr(5, 9)) >= 0);

    }

    imageSize(files: any, minmax: string | 'MIN' | 'MAX' | 'FIX', width: number, height: number): Observable<number> {

        return Observable.create(observer => {

            let erro: string;
            let qtde: number;

            let totalLoad = 0;
            let countLoad = files.length;

            files.forEach(file => {

                let mime = (file.substr(0, 11) == 'data:image/' ? '' : 'data:image/jpeg;base64,');

                let myImage = new Image;
                myImage.src = mime + file;
                myImage.onload = () => {

                    let bmin = ((width == 0 || myImage.naturalWidth >= width) && (height == 0 || myImage.naturalHeight >= height));
                    let bmax = ((width == 0 || myImage.naturalWidth <= width) && (height == 0 || myImage.naturalHeight <= height));
                    let bfix = ((width == 0 || myImage.naturalWidth == width) && (height == 0 || myImage.naturalHeight == height));

                    if (erro) return;
                    if (files.length == 1 && minmax == 'MIN' && !bmin) erro = 'Tamanho min inválido ' + myImage.naturalWidth + 'x' + myImage.naturalHeight;
                    if (files.length == 1 && minmax == 'MAX' && !bmax) erro = 'Tamanho max inválido ' + myImage.naturalWidth + 'x' + myImage.naturalHeight;
                    if (files.length == 1 && minmax == 'FIX' && !bfix) erro = 'Tamanho fix inválido ' + myImage.naturalWidth + 'x' + myImage.naturalHeight;

                    if (files.length > 1  && minmax == 'MIN' && !bmin) qtde++;
                    if (files.length > 1  && minmax == 'MAX' && !bmax) qtde++;
                    if (files.length > 1  && minmax == 'FIX' && !bfix) qtde++;

                    if (files.length > 1 && qtde) erro = qtde + ' imagens com tamanho inválido.';

                    totalLoad++;
                    if (totalLoad == countLoad) {
                        if (erro) observer.error(erro);
                        if (!erro) observer.next();
                        observer.complete();
                    }

                };

                myImage.onerror = () => {
                    observer.error('Erro-Develop: "new Image"');
                    observer.complete();
                };

            });

        });
    }

    pngTransparent(base64): Observable<number> {

        return Observable.create(observer => {

            var canvas = document.createElement('canvas');

            let detectColor = (ctx, x, y) => {
                let data = ctx.getImageData(x, y, 1, 1).data;
                let pixel = {r: data[0], g: data[1], b: data[2], a: data[3]};

                return pixel;
            };

            let mime = (base64.substr(0, 11) == 'data:image/' ? '' : 'data:image/png;base64,');

            let myImage = new Image;
            //myImage.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            myImage.src = mime + base64;
            myImage.onload = () => {

                canvas.width = myImage.naturalWidth;
                canvas.height = myImage.naturalHeight;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(myImage, 0, 0);

                let lin = (myImage.naturalWidth / 10);
                let col = (myImage.naturalHeight / 10);

                let count = 0;
                for (let x = 0; x <= myImage.naturalWidth; x += col) {

                    for (let y = 0; y <= myImage.naturalHeight; y += lin) {

                        x = Math.floor(x);
                        y = Math.floor(y);

                        let pix = detectColor(ctx, x, y);
                        if (pix.a == 0) count++;

                    }

                }

                if (count > 0) observer.next();
                if (count == 0) observer.error();
                observer.complete();

            };

        });

    }

    //Select Files and Convert To Base64
    fileSelect(options: {acceptTypes: 'youtube' | string, sizebyte?: number, selectLimit?: number, minmax?: string | 'MIN' | 'MAX' | 'FIX', width?: number, height?: number, quality?: number}): Observable<any[]> {

        options.selectLimit = options.selectLimit ? options.selectLimit : 1;
        //options.width = options.width ? options.width : 1920;
        //options.height = options.height ? options.height : 1920;
        options.quality = options.quality ? options.quality : 80;

        // LARGURA e ALTURA funcionam apenas no nativo

        return Observable.create(observer => {
            //.timer(2000,5000)

            if (this.nativeApp()) {

                if (options.acceptTypes.indexOf('image/') >= 0) {

                    let imgOptions: ImagePickerOptions = {
                        //width: options.width,
                        //height: options.height,
                        quality: options.quality,
                        maximumImagesCount: options.selectLimit,
                        outputType: OutputType.DATA_URL
                    };

                    this.imagePicker.getPictures(imgOptions).then(
                        data => this._fileParse(observer, null, data, options.acceptTypes, options.minmax, options.width, options.height),
                        erro => {

                            erro = {Titulo: 'Ops!', result: erro};
                            observer.error(erro);
                            observer.complete();

                        });

                } else if (options.acceptTypes.indexOf('audio/') >= 0) {

                    let erro = {Titulo: 'Ops!', Result: 'Músicas podem ser enviadas apenas pelo computador.'};
                    observer.error(erro);
                    observer.complete();

                }

            } else {

                let input: any = document.createElement("input");

                input.type = 'file';
                input.accept = options.acceptTypes;

                if (options.selectLimit != 1) input.multiple = 'multiple';


                input.onchange = event => {

                    let filesBase64: string[] = [];
                    let totalLoad: number = 0;

                    let countLoad = event.target.files.length;
                    for (let i in event.target.files) {

                        let file = event.target.files[i];
                        if (typeof file != 'object') continue;

                        //file.type == "image/png"
                        //file.size

                        let erro: any;
                        let myReader: FileReader = new FileReader();
                        myReader.readAsDataURL(file);
                        myReader.onloadend = (loadEvent: any) => {

                            if (erro) return;
console.log(file, loadEvent);//text/csv
                            if (!this.mimeAllow(file.type, options.acceptTypes)) {
                          //if (!this.mimeAllow(loadEvent.target.result, options.acceptTypes)) {
                                erro = {Titulo: 'Ops!', Result: 'Tipo de arquivo inválido.'};
                            } else if (options.sizebyte && file.size > options.sizebyte) {
                                console.log(options.sizebyte, file.size);
                                erro = {
                                    Titulo: 'Ops!',
                                    Result: 'Tamanho superior a ' + this.formatByte(options.sizebyte)
                                };
                            }

                            if (erro) {
                                observer.error(erro);
                                observer.complete();
                                return;
                            }

                            filesBase64.push(loadEvent.target.result);

                            totalLoad++;
                            if (totalLoad == countLoad) {
                                this._fileParse(observer, file, filesBase64, options.acceptTypes, options.minmax, options.width, options.height);
                            }

                        };

                    }

                };

                input.click();

            }

        });

    }

    private _fileParse(observer: Observer<any>, fileinfo: any, fileLink: any, mime: string = '', minmax: string | 'MIN' | 'MAX' | 'FIX' = 'MAX', width: number = 0, height: number = 0) {

        let results: any[] = [];

        fileLink.forEach(send => {

            //MD5 1.8mb 50x - menos de 2s
            let hash = sparkMD5.hash(send);
            let item = {base64: send, hash: hash, info: fileinfo};
            results.push(item);

        });

        let fail = null;
        if (fileLink.length == 0) fail = {Titulo: 'Arquivo-File', Result: 'Arquivo não informado'};
        if (results.length == 0)  fail = {Titulo: 'Arquivo-File', Result: 'Arquivo inválido'};

        if (fail) {
            observer.error(fail);
            observer.complete();
            return;
        }

        //Fim para arquivo: PDF, etc...
        if (!this.mimeAllow(mime, 'image/png,image/jpeg,image/png,image/gif')) {
            observer.next(results);
            observer.complete();
            return;
        }

        //Fim para imagens: PNG, etc...
        this.imageSize(fileLink, minmax, width, height)
            .finally(() => observer.complete())
            .subscribe(
                data => observer.next(results),
                erro => observer.error({Titulo: 'Ops', Result: erro})
            );

    }



    getBase64Image(url, base64Only: boolean = false): Observable<string> {

        return Observable.create(observer => {
            //.timer(2000,5000)

            //Nao passou url nenhuma
            if (!url) {
                observer.error(CONFIG.request.bridgeErroPadrao);
                observer.complete();
                return;
            }

            setTimeout(() => {

                observer.error(CONFIG.request.timeoutErroPadrao);
                observer.complete();

            }, CONFIG.request.totalTimeout);

            let xhr = new XMLHttpRequest();
            xhr.onload = () => {
                let myReader = new FileReader();
                myReader.readAsDataURL(xhr.response);

                myReader.onloadend = () => {

                    let base64 = myReader.result;
                    if (base64Only) base64 = (base64 as string).substring(23);

                    observer.next(base64);
                    observer.complete();
                };

                myReader.onerror = () => {
                    observer.error(CONFIG.request.bridgeErroPadrao);
                    observer.complete();
                };
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();

        })
        //.timeout(200, new Error('Tempo limite excedido. Tente novamente'));

    }

    pictureOpen(input): Observable<any> {

        //#ELLzito - 2023: Verificar esse plugin para rotate image
        //https://github.com/Riyaz0001/cordova-plugin-image-cropper

        return Observable.create((observer: Observer<any>) => {

            let onData = (data, erro) => {
                if (erro) observer.error(erro);
                if (!erro) observer.next(data);
                observer.complete();
            };

            if (!this.nativeApp()) {
                onData(null, null);
                input.nativeElement.click();
                return;
            }

            let onFoto = (type) => {

                let onFile = (data64) => {
                    this.pictureLoad(data64, true).subscribe(
                        data => onData(data, null),
                        erro => onData(null, erro)
                    );
                };

                const options: CameraOptions = {
                    quality: 85,
                    //allowEdit: true,  -> Retorna "No Image Selected"
                    targetWidth: 720,
                    correctOrientation: true,
                    destinationType: this.camera.DestinationType.DATA_URL,
                    encodingType: this.camera.EncodingType.JPEG,
                    mediaType: this.camera.MediaType.PICTURE,
                    sourceType: type
                };

                this.camera.getPicture(options).then(
                    data => onFile(data),
                    erro => onData(null, (erro == 'no image selected' ? null : 'Houve um problema para tirar foto.')));
                  //erro => { alert(JSON.stringify(erro)); onData(null, 'Houve um problema para tirar foto.')});

            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Galeria', handler: () => onFoto(this.camera.PictureSourceType.PHOTOLIBRARY)});
            buttons.push({text: 'Camera',  handler: () => onFoto(this.camera.PictureSourceType.CAMERA)});
            buttons.push({text: 'Cancelar', role: 'cancel'});
            this.sheetOpen(buttons, 'FOTO');

        });

    }

    pictureLoad(eventOrBase64, isNative = false): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let loading = this.loadingDots();
            loading.present();

            let onExec = (data, erro) => {

                setTimeout(() => {
                    loading.dismiss();
                    if (erro) observer.error(erro);
                    if (!erro) observer.next(data);
                    observer.complete();
                }, 1000);

            };

            if (isNative) {
                onExec(eventOrBase64, null);
                return;
            }

            let file: File = eventOrBase64.target.files[0];
            let myReader: FileReader = new FileReader();
            myReader.readAsDataURL(file);

            myReader.onloadend = (loadEvent: any) => {

                if (loadEvent.target.result.substr(0, 11) !== 'data:image/') {
                    onExec(null, 'Selecione um arquivo de imagem.');
                    return;
                }

                onExec(loadEvent.target.result, null);

            };

        });

    }

    midiasee(galeriaTipo: TGaleriaTipo, galeria, $event: any = null, player: any = null, id: any = null) {

        if (galeriaTipo == TGaleriaTipo.gtPlace) this.photosee(galeria);
        if (galeriaTipo == TGaleriaTipo.gtPhoto) this.photosee(galeria);
        if (galeriaTipo == TGaleriaTipo.gtVideo) this.moviesee(galeria, $event, player, id);
        if (galeriaTipo == TGaleriaTipo.gtMusic) this.musicsee(galeria);

    }

    musicand(file): boolean {

        return (this.audioSound && !this.audioSound.paused && this.audioSound.src == file);

    }

    musicsee(galeria, checkPlaying: boolean = false): boolean {

        if (!galeria.GaleriaFile) return false;
        let src = (galeria.GaleriaFile.base64 ? galeria.GaleriaFile.base64 : galeria.GaleriaFile);

        //Just check playing
        let playing = this.musicand(src);
        if (checkPlaying) return playing;

        //Play ou Pause
        if (playing) {
            this.audioSound.pause();
        } else {
            if (!this.audioSound) this.audioSound = new Audio(galeria.GaleriaFile);
            this.audioSound.src = src;
            this.audioSound.play();
        }

        return !playing;

    }

    moviesee(galeria, $event: any = null, player: any = null, id: any = null) {

        if (!player || !id) {
            this.showVideo = galeria.GaleriaEmbed;
            return;
        }

        if (player) player = player.GaleriaEmbed.split('/').reverse()[0];

        if (player.data == 0) {
            this.showVideo = false;
            return;
        }

        this.players[id] = player;

    }

    photosee(galeria, index: number = 0) {

        if (!galeria) return;

        let gallery = [];

        galeria.Value.forEach(galeriaMap => {
            gallery.push({
                'src': galeriaMap.GaleriaFile,
                'thumb': galeriaMap.GaleriaFile,
                'subHtml': '<h4>' + galeriaMap.GaleriaHtml + '</h4>'
            });
        });

        if (gallery.length == 0) {
            this.toastSimply('Não existe foto nesse album.');
            return;
        }

        //Exemplo quando já está carregado no HTML
        //let bt = this.lgBts.toArray().find((e) => {
        //    return e.nativeElement.getAttribute('id') == index;
        //}).nativeElement;
        //(<any>window).$('bt').lightGallery({

        // LightGallery = carregar a galeria toda mas abrir pelo index
        let galling = (<any>window).$('body').append('<div></div>').find('div:last');
        galling.lightGallery({share: false, hash: false, dynamic: true, dynamicEl: gallery, index: index});

        setTimeout(() => galling.data('lightGallery').slide(index));
    }

    //#MIGRATE
    qrcolor(imgUrl, top, end): Observable<string> {

        return new Observable(observer => {

            (function (global: any) {

                'use strict';

                var fabric = global.fabric || (global.fabric = {}),
                    extend = fabric.util.object.extend;

                fabric.Image.filters.GradientEffect = fabric.util.createClass(fabric.Image.filters.BaseFilter, {

                    type: 'GradientEffect',

                    initialize: function (options) {
                        options = options || {};
                        this.gradient = options.gradient || {};
                        this.width = options.width || 0;
                        this.height = options.height || 0;
                    },

                    applyTo: function (canvasEl) {

                        let gr = this.gradient;
                        let w = this.width;
                        let h = this.height;
                        let hc = document.createElement('canvas');
                        hc.setAttribute('width', w);
                        hc.setAttribute('height', h);

                        let rect = new fabric.Rect({fill: 'transparent', width: w, height: h});
                        rect.setGradient('fill', gr);
                        let fhc = new fabric.Canvas(hc);
                        fhc.add(rect);
                        fhc.renderAll();

                        let ifhcContext = fhc.getContext('2d');
                        let fhcImageData = ifhcContext.getImageData(0, 0, fhc.width, fhc.height);
                        let fhcData = fhcImageData.data;

                        let context = canvasEl.getContext('2d'),
                            imageData = context.getImageData(0, 0, canvasEl.width, canvasEl.height),
                            data = imageData.data;

                        for (let i = 0, n = data.length; i < n; i += 4) {
                            data[i] += fhcData[i];
                            data[i + 1] += fhcData[i + 1];
                            data[i + 2] += fhcData[i + 2];

                        }

                        context.putImageData(imageData, 0, 0);
                    },

                    toObject: function () {
                        return extend(this.callSuper('toObject'), {
                            gradient: this.gradient
                        });
                    }
                });

                fabric.Image.filters.GradientEffect.fromObject = function (object) {
                    return new fabric.Image.filters.GradientEffect(object);
                };

            })(window);

            let canvas = new fabric.Canvas(document.createElement('canvas'));

            fabric.Image.fromURL(imgUrl, (img) => {
                let gr = {x1: 0, y1: 0, x2: 0, y2: 328, colorStops: {0: top, 1: end}};
                let object = {gradient: gr, width: 328, height: 328};
                img.filters.push(new fabric.Image.filters.GradientEffect(object));

                //img.applyFilters();
                //canvas.requestRenderAll(); // or the old canvas.renderAll() if you prefer or need it
                // Optionally you can pass a filters array to applyFilter
                // if you want to apply something that is not the image filter chain.
                //img.applyFilters([ new fabric.Image.filters.Contrast({ contrast: 15 })]);

                //console.log(img);

                img.applyFilters(canvas.renderAll.bind(canvas));

                setTimeout(() => {
                    observer.next(img._element.attributes.src.nodeValue);
                    observer.complete();
                }, 500);

            }, {
                crossOrigin: ''
            });

        });

    }

}



// WEBPACK FOOTER //
// ./src/app/util.ts